import {isDarkMode} from "../utils/DOMUtils";
import useLocalStorage from "./useLocalStorage";
import {useEffect, useState} from "react";

export default function useDarkMode() {
    const [darkMode, setDarkMode] = useState(isDarkMode());

    const [theme] = useLocalStorage("theme", "", {isPrivate: true, sync: true});

    useEffect(() => {
        setDarkMode(isDarkMode());
    }, [theme]);

    console.error("CHANGE MODE", darkMode);
    return darkMode;
}
